import { createRouter, createWebHashHistory } from 'vue-router'
import Home from '../views/Home.vue'
import firebase from 'firebase/app'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: {
      title: 'RaidRoster',
    },
  },
  {
    path: '/roster',
    name: 'Roster',
    component: () => import( '../views/Roster.vue'),
    meta: {
      authRequired: true,
    },
  },
  {
    path: '/signin',
    name: 'signin',
    component: () => import('../views/Signin.vue'),
  },
  {
    path: '/join',
    name: 'join',
    component: () => import('../views/Join.vue'),
  },
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

router.beforeEach((to, from, next) => {
  if ( to.matched.some( record => record.meta.authRequired ) ) {
    if ( firebase.auth().currentUser ) {
      next();
    }
    else {
      next({
        path: '/signin',
      });
    }
  }
  else {
    next();

  }
});

export default router
